// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"8a57eb37","239":"e8373869","453":"4114d2e6","455":"9ca687b7","977":"e0bb8548"}[chunkId] + ".chunk.js";
};